export enum PeriodOfDay {
  Morning = 'morning',
  Evening = 'evening',
}

export enum DayNight {
  Day = 'day',
  Night = 'night',
}

export enum QualityOption {
  PH = 'pH',
  Temperature = 'temperature',
  Alkali = 'alkali',
  Nitrite = 'nitrite',
  DO = 'DO',
  Ammonia = 'ammonia',
  Terbidity = 'terbidity',
  Salinity = 'salinity',
}

/**
 * label and unit are keys for i18n
 */
export const WATER_QUALITY_OPTIONS = [
  {
    category: QualityOption.PH,
    label: 'pH',
    unit: '',
  },
  {
    category: QualityOption.Alkali,
    label: 'alkali',
    unit: 'ppm',
  },
  {
    category: QualityOption.Temperature,
    label: 'temperature',
    unit: '°C',
  },
  {
    category: QualityOption.Nitrite,
    label: 'nitrite',
    unit: 'ppm',
  },
  {
    category: QualityOption.DO,
    label: 'do',
    unit: 'ppm',
  },
  {
    category: QualityOption.Ammonia,
    label: 'ammonia',
    unit: 'ppm',
  },
  {
    category: QualityOption.Terbidity,
    label: 'terbidity',
    unit: 'NTU',
  },
  {
    category: QualityOption.Salinity,
    label: 'salinity',
    unit: 'ppt',
  },
]

export enum MineralType {
  Calcium = 'calcium',
  Magnesium = 'magnesium',
  Potassium = 'potassium',
}

/**
 * label and unit are keys for i18n
 */
export const MINERALS = [
  {
    name: MineralType.Calcium,
    label: 'calcium',
    unit: 'ppm',
  },
  {
    name: MineralType.Magnesium,
    label: 'magnesium',
    unit: 'ppm',
  },
  {
    name: MineralType.Potassium,
    label: 'potassium',
    unit: 'ppm',
  },
]

export enum Vibrios {
  Green = 'greenVibrio',
  Yellow = 'yellowVibrio',
}

export const VIBRIOS = [
  {
    name: Vibrios.Green,
    label: 'green.vibrio',
    unit: 'cfu/ml',
  },
  {
    name: Vibrios.Yellow,
    label: 'yellow.vibrio',
    unit: 'cfu/ml',
  },
]
